import * as actions from './actionTypes';
import { setLoading, setMessage } from './general';
import axios from '../../config/axiosInstance';

export const fetchTaskSchedulesSuccess = tasks => ({
  type: actions.FETCH_TASK_SCHEDULES_SUCCESS,
  tasks,
});

export const fetchTaskSchedules = () => (dispatch) => {
  dispatch(setLoading(true));
  return axios
    // .get('/event/events')
    .get('/event/pending')
    .then((response) => {
      dispatch(fetchTaskSchedulesSuccess(response.data));
      dispatch(setLoading(false));
      return Promise.resolve(response.data);
    })
    .catch((error) => {
      dispatch(setLoading(false));
      dispatch(setMessage(error));
      return Promise.reject(error);
    });
};

export const updateTaskScheduleNameSuccess = (id, name, description) => ({
  type: actions.UPDATE_TASK_SCHEDULES_SUCCESS,
  id,
  name,
  description,
});

export const updateTaskScheduleName = (id, name, description) => (dispatch) => {
  dispatch(setLoading(true));
  axios
    .put('/event/', {
      id,
      statusaction: name,
      description: description,
    })
    .then((_) => {
      dispatch(updateTaskScheduleNameSuccess(id, name, description));
      dispatch(setLoading(false));
      dispatch(setMessage('Ponto atualizado com sucesso'));
    })
    .catch((_) => {
      dispatch(setLoading(false));
      dispatch(setMessage('O Ponto não pode ser atualizado'));
    });
};